import Request from '../utils/Request';
import { GoogleSpreadsheet } from 'google-spreadsheet';
const credentials = require('../sinergi-karya-sejahtera-1a1ae27bde43.json');

class JobsService {
    //wp backend
    // static getAll(){
    //     return Request.make('GET',`jobs`);
    // }
    // static search(query){
    //     return Request.make('GET',`search?subtype=jobs&per_page=2&${query}`);
    // }
    // static show(id){
    //     return Request.make('GET',`jobs/${id}`)
    // }
    async loadDocument(language){
        const languages = {
            'english' : 1,
            'indonesian' : 0
        }

        // Initialize the sheet - doc ID is the long id in the sheets URL
        const doc = new GoogleSpreadsheet(process.env.REACT_APP_SPREADSHEET_ID);
        // Initialize Auth - see more available options at https://theoephraim.github.io/node-google-spreadsheet/#/getting-started/authentication
        await doc.useServiceAccountAuth(credentials);

        await doc.loadInfo(); // loads document properties and worksheets
        const sheet = doc.sheetsByIndex[languages[language]]; // or use doc.sheetsById[id] or doc.sheetsByTitle[title]
        const rows = await sheet.getRows();
        return rows;
    }
    //google sheets api
    constructor(language){
        this.language = language
        this.jobs = this.loadDocument(language);
    }

}
export default JobsService;